import Splide from "@splidejs/splide"

export default () => {
  const banner_splide = document.querySelector("#banner_splide");
  banner_splide ? new Splide(banner_splide, {
    type       : "slide",
    arrows     : false,
    rewind     : true,
    keyboard   : "focused",
    classes: {
      pagination: 'splide__pagination hero__pagination',
      page      : 'splide__pagination__page hero__pagination__page',
    },
    autoplay: true,
    interval: 4000
  }).mount() : ""
}

